import { render, staticRenderFns } from "./IconNotification.vue?vue&type=template&id=0670dcc5"
import script from "./IconNotification.vue?vue&type=script&lang=js"
export * from "./IconNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports